module.exports = __webpack_public_path__ + "img/hitbtc.9cd166f7.svg";